// 文档链接配置
import React from 'react';

const DOC_DOMAIN = 'https://bugly.tds.qq.com/docs';

export default {
  docRoot: DOC_DOMAIN,
  quickStart: `${DOC_DOMAIN}/quick_start/create_product`,
  relateProduct: `${DOC_DOMAIN}/quick_start/relate_product`,
  buglyQQMessage: <span>如果你之前已经在Bugly QQ上注册过相同产品，请选择对应产品的APPID。更多细节请查看<a target={'_blank'} href={`${DOC_DOMAIN}/quick_start/relate_product`}>《关联Bugly QQ的相同产品指引》</a></span>,
  alarmQuickStart: `${DOC_DOMAIN}/tutorial/alarm/#%E5%91%8A%E8%AD%A6%E9%80%9A%E7%9F%A5`,
  configQuickStart: `${DOC_DOMAIN}/tutorial/config/sdk_config`,

  uuidDoc: `${DOC_DOMAIN}/tutorial/symbol/uuid`,
  searchDoc: `${DOC_DOMAIN}/tutorial/analysis/search`,
  iosExitDoc: `${DOC_DOMAIN}/feature/iOS/appexit`,
  iosTickInfoDoc: `${DOC_DOMAIN}/tutorial/iOS/appexit#tick-info`,
  iosExitInfoDoc: `${DOC_DOMAIN}/tutorial/iOS/appexit#exit-info`,
  iosVmmapInfoDoc: `${DOC_DOMAIN}/tutorial/iOS/appexit#vmmap-info`,
  androidApplicationExitInfo: 'https://developer.android.com/reference/android/app/ApplicationExitInfo',
  dominatortreeDoc: 'https://help.eclipse.org/latest/index.jsp?topic=%2Forg.eclipse.mat.ui.help%2Fconcepts%2Fdominatortree.html',
  androidNetDoc: `${DOC_DOMAIN}/tutorial/Android/net_quality/`,
  iosNetDoc: `${DOC_DOMAIN}/tutorial/iOS/network_monitor`,
  relatedBuglyqqDoc: `${DOC_DOMAIN}/quick_start/relate_product`,
  attachmentDoc: `${DOC_DOMAIN}/tutorial/analysis/attachment/`,
  guideDoc: `${DOC_DOMAIN}/tutorial/metric/`,
  otherUploadMethodsDoc: `${DOC_DOMAIN}/tutorial/symbol/tool`,
  symbolGuideDoc: `${DOC_DOMAIN}/tutorial/symbol/summary`,
  qualityReport: `${DOC_DOMAIN}/tutorial/quality_report/quality_rule`,
};
